import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateZone(
    $updateZoneId: ID!
    $updates: ZoneUpdates!
    $tenantId: ID!
  ) {
    tenant(id: $tenantId) {
      updateZone(id: $updateZoneId, updates: $updates) {
        id
        code
        alias
        name
        description
        createdBy
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateZoneMutation,
    ents.core.admin.Zone,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'updateZone',
      graphql.transformers.OUT.object({
        alias: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        code: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        description: transformers.PASS_THROUGH,
        createdBy: transformers.PASS_THROUGH,
        id: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        name: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
      }),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateZoneMutation,
  ents.core.admin.Zone,
  graphql.schema.UpdateZoneMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
